import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addToolsFailure,
  addToolsSuccess,
  deleteToolsFailure,
  //
  deleteToolsSuccess,
  editToolsFailure,
  //
  editToolsSuccess,
  fetchToolsFailure,
  fetchToolsSuccess,
  //
  getViewDataFailure,
  getViewDataSuccess,
  //
  getResidentToolDataFailure,
  getResidentToolDataSuccess,
  //
  updateToolSequenceFailure,
  updateToolSequenceSuccess,
  //
  toggleToolLocationSettingFailure,
  toggleToolLocationSettingSuccess,
  //
  searchToolsFailure,
  searchToolsSuccess,
  //
  getToolSnapshotsFailure,
  getToolSnapshotsSuccess,
} from "./actions";
import {
  ADD_TOOLS,
  DELETE_TOOLS,
  EDIT_TOOLS,
  FETCH_TOOLS,
  GET_VIEW_DATA,
  GET_RESIDENT_TOOL_DATA,
  UPDATE_TOOL_SEQUENCE,
  TOGGLE_TOOL_LOCATION_SETTING,
  SEARCH_TOOLS,
  GET_TOOL_SNAPSHOTS,
} from "./constants";

export function* fetchToolsSaga({
  payload = { cancelToken: null },
  onSuccess,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.data ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/assessment-tool?${query}`,
      payload,
    );
    if (payload?.data?.type === "chart") {
      console.log("[Charts] assessment-tool response", data);
    }
    yield put(fetchToolsSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(fetchToolsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching network!"));
  }
}

export function* getViewDataSaga({
  payload = { cancelToken: null },
  onSuccess,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/assessment-tool/${payload}`,
    );
    yield put(getViewDataSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addToolsSaga({ payload, onAdd }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/assessment-tool/add`,
      payload,
    );
    if (data) {
      yield put(successAlert("Tool added successfully!"));
      yield put(addToolsSuccess());
      typeof onAdd === "function" && onAdd();
    }
  } catch (e) {
    yield put(addToolsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editToolsSaga({ payload, onEdit }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/assessment-tool/edit/${payload.id}`,
      payload.data,
    );
    if (data) {
      yield put(successAlert("Tool updated successfully!"));
      yield put(editToolsSuccess());
      typeof onEdit === "function" && onEdit(data);
    }
  } catch (e) {
    yield put(editToolsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteToolsSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  try {
    const data = yield call(
      api(token).delete,
      `/api/assessment-tool/${payload?.delete_id}`,
    );
    if (data) {
      yield put(successAlert("Tool deleted successfully!"));
      yield put(deleteToolsSuccess());
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteToolsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getResidentToolDataSaga({
  payload = { cancelToken: null },
  onSuccess,
}) {
  const { resident_id, tool_identifier, filters } = payload;
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = QueryString.stringify(filters);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident-live-chart/${resident_id}/${tool_identifier}?${query}`,
    );
    yield put(getResidentToolDataSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(getResidentToolDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* updateToolSequenceSaga({ payload, onEdit }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const activeLocation = yield select(
    (state) => state?.SlickCareProfilesReducer?.activeLocation,
  );
  try {
    const data = yield call(api(token).post, `/api/assessment-tool-sequence`, {
      // location_id is REQUIRED for reordering default rows.
      location_id: activeLocation?.id,
      ...payload,
    });
    if (data) {
      yield put(successAlert("Sequence updated successfully!"));
      yield put(updateToolSequenceSuccess());
      typeof onEdit === "function" && onEdit(data);
    }
  } catch (e) {
    yield put(updateToolSequenceFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* toggleToolLocationSettingSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { id, isEnabled, locationId, sortOrder } = payload;
  try {
    const body = { location_id: locationId };
    if (isEnabled !== undefined) body.is_enabled = isEnabled;
    if (sortOrder !== undefined) body.sort_order = sortOrder;

    const data = yield call(
      api(token).post,
      `/api/assessment-tool/location-setting/${id}`,
      body,
    );
    if (data) {
      yield put(
        successAlert(
          isEnabled === false
            ? "Chart disabled for this home."
            : "Chart enabled for this home.",
        ),
      );
      yield put(toggleToolLocationSettingSuccess());
      typeof onSuccess === "function" && onSuccess(data);
    }
  } catch (e) {
    yield put(toggleToolLocationSettingFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* searchToolsSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = QueryString.stringify(payload);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/assessment-tool/search?${query}`,
    );
    yield put(searchToolsSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(searchToolsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getToolSnapshotsSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = QueryString.stringify(payload);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/tool-chart-snap-details?${query}`,
    );
    yield put(getToolSnapshotsSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(getToolSnapshotsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchToolsFlow() {
  yield takeEvery(FETCH_TOOLS, fetchToolsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addToolsFlow() {
  yield takeEvery(ADD_TOOLS, addToolsSaga);
}
export function* editToolsFlow() {
  yield takeEvery(EDIT_TOOLS, editToolsSaga);
}
export function* deleteToolsFlow() {
  yield takeEvery(DELETE_TOOLS, deleteToolsSaga);
}
export function* getResidentToolDataFlow() {
  yield takeEvery(GET_RESIDENT_TOOL_DATA, getResidentToolDataSaga);
}
export function* updateToolSequenceFlow() {
  yield takeEvery(UPDATE_TOOL_SEQUENCE, updateToolSequenceSaga);
}
export function* toggleToolLocationSettingFlow() {
  yield takeEvery(TOGGLE_TOOL_LOCATION_SETTING, toggleToolLocationSettingSaga);
}
export function* searchToolsFlow() {
  yield takeEvery(SEARCH_TOOLS, searchToolsSaga);
}
export function* getToolSnapshotsFlow() {
  yield takeEvery(GET_TOOL_SNAPSHOTS, getToolSnapshotsSaga);
}
export default function* ResidentToolsSaga() {
  yield all([
    fetchToolsFlow(),
    getViewDataFlow(),
    addToolsFlow(),
    editToolsFlow(),
    deleteToolsFlow(),
    getResidentToolDataFlow(),
    updateToolSequenceFlow(),
    toggleToolLocationSettingFlow(),
    searchToolsFlow(),
    getToolSnapshotsFlow(),
  ]);
}
